import { Camera } from './camera.model';
import { User } from './user.model';
import { Model } from './model';
import * as moment from 'moment';

export class ConfigModel extends Model {

  public _id: string
  public name: string
  public fb_app_id: String
  public fb_client_token: String
  public fb_group_id: String
  public raspivid_w: Number
  public raspivid_h: Number
  public raspivid_fps: Number
  public raspivid_b: Number

  constructor(data = {}) {
    super(data);
  }

  get attributeMap(): { [p: string]: any } {
    return {
      _id: String,
      name: String,
      fb_app_id: String,
      fb_client_token: String,
      fb_group_id: String,
      raspivid_w: Number,
      raspivid_h: Number,
      raspivid_fps: Number,
      raspivid_b: Number
    };
  }

}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/models/config-model.model.ts